// extracted by mini-css-extract-plugin
module.exports = {"kiteAnimation":"kite_kiteAnimation__by7sI","st0":"kite_st0__CDFZ1","st1":"kite_st1__jc46y"};